import { useState, useEffect } from 'react'

import type { StepName } from '@/features/proposta/entities/Comprador/steps'
import type { TCompradoresCadastrados } from '@/features/proposta/interfaces/proposta.type'
import type { TProcuradorPropostaSchema } from '@/features/proposta/schemas'

export function useStepManager<TVals, TOut, S extends StepName>(
  initialSteps: (
    values: TVals,
    compradores?: TCompradoresCadastrados,
    procuradores?: TProcuradorPropostaSchema[],
  ) => readonly S[],
  watchValues: () => TVals,
  onCancel: () => void,
  onSubmit: (vals: TOut, isDirty: boolean) => Promise<void>,
  isDirty: boolean,
  compradores?: TCompradoresCadastrados,
  procuradores?: TProcuradorPropostaSchema[],
) {
  const steps = initialSteps(watchValues(), compradores, procuradores)
  const [idx, setIdx] = useState(0)

  useEffect(() => {
    setIdx((i) => Math.min(i, steps.length - 1))
  }, [steps])
  const isLast = idx === steps.length - 1

  const onNext = () => {
    if (!isLast) setIdx((i) => i + 1)
  }

  const onFinish = (value: TOut) => {
    return onSubmit(value, isDirty)
  }

  const onBack = () => {
    if (idx === 0) onCancel()
    else setIdx((i) => i - 1)
  }

  return { steps, idx, onNext, onBack, onFinish, isLast }
}
